module.exports = __webpack_public_path__ + "static/media/StarRightSecondary.d3d33da1.svg";